import "./components/swiper";
import "./components/compote";
// import "./components/tomselect";
// import "./components/photoswipe";
import "./components/custom-van11y-modal";
// import "./components/modal";
// import "./components/tab";
// import "./components/tooltip";
import "./components/accordeon";

import "./global/init";
import "./global/navigation";
import "./global/form";
